/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/

import React from "react";
import { Modal } from "react-bootstrap";
import { qreq } from "../shared/qrequest";
import L from "./Lang"
import BaseCom from "./BaseCom";
import Card from "./Card";
import Icon from "./Icon";
import './PatientLifecycle.css';
import FormInput from "./FormInput";
import Globals from "../shared/Globals";
import FormLabel from "./FormLabel";
import Wound from "./Wound";
import { Link } from "react-router-dom";

export const PatientLifecycleGlobal = {
    showSelect() { }
}

class DetailPhaseModal extends BaseCom {
    constructor(props) {
        super(props);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.load = this.load.bind(this);
        this.loadExam = this.loadExam.bind(this);
        PatientLifecycleGlobal.showDetail = this.show;
    }

    componentDidMount() {
        this.setState({ show: this.props.show, order: { ...this.props.order } });
    }

    componentDidUpdate(prevProps) {
        if (this.props.show !== prevProps.show) {
            this.setState({ show: this.props.show });
            this.load(this.props.phase);
        }
        if (this.props.order !== prevProps.order) {
            this.setState({ order: { ...this.props.order } });
            this.load(this.props.phase);
        }
        if (this.props.phase !== prevProps.phase) {
            this.load(this.props.phase);
        }
    }

    load(phase) {
        if (!phase?.id)
            return;
        qreq.get('/api/phase/order/' + this.props.order.id + '/get/' + phase.id, j => {
            if (j.item) {
                this.setState({ orderPhase: j.item });
                this.loadExam(phase);
                this.loadWounds(phase);
            }
            else if (j.errorCode === 4)
                this.setState({ orderPhase: {} });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    loadExam(phase) {
        if (!phase?.id)
            return;
        qreq.get('/api/examination/order/' + this.props.order.id + '/phase/' + phase.id, j => {
            if (j.item) {
                try {
                    var exam = JSON.parse(j.item.jsonData);
                    this.setState({ exam: exam, examObj: j.item });
                }
                catch {
                    this.setState({ exam: null, examObj: null });
                }
            }
            else if (j.errorCode === 4)
                this.setState({ exam: null, examObj: null });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    loadWounds(phase) {
        if (!phase?.id)
            return;
        qreq.get('/api/wound/order/' + this.props.order.id + '/phase/' + phase.id, j => {
            if (j.list) {
                this.setState({ wounds: j.list });
            }
            else if (j.errorCode === 4)
                this.setState({ wounds: null });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    show() {
        this.setState({ show: true });
    }

    hide(success) {
        this.props.onHide?.();
        if (success)
            this.props.onSuccess?.();
        this.setState({ show: false });
    }

    render() {
        if (!this.state.show) return;
        return <Modal show={this.state.show} onHide={this.hide} size="xl">
            <Modal.Header closeButton className="d-flex align-items-baseline justify-content-between">
                <Modal.Title>{this.props.phase?.name}</Modal.Title>
                <div className="ms-3 text-muted"><L>Phase Details</L></div>
            </Modal.Header>
            <form onSubmit={this.submit}>
                <Modal.Body>
                    {this.state.orderPhase && <Card>
                        <div className="row">
                            <div className="col-md-4"><FormLabel model={Globals.toMDYHMLocalDateString(this.state.orderPhase?.touchDate)} label="Assigned On" /></div>
                            {this.state.orderPhase.touchedByUserName && <div className="col-md-4"><FormLabel model={this.state.orderPhase.touchedByUserName} label="Assigned By" /></div>}
                            {this.state.orderPhase.assignedToUserName && <div className="col-md-4"><FormLabel model={this.state.orderPhase.assignedToUserName} label="Assigned To" /></div>}
                        </div>
                        <div className="row">
                            {this.state.orderPhase.performedByUserID !== 0 && <div className="col-md-4"> <FormLabel model={Globals.toMDYHMLocalDateString(this.state.orderPhase?.performedDate)} label="Performed On" /></div>}
                            {this.state.orderPhase.performedByUserName && <div className="col-md-4"><FormLabel model={this.state.orderPhase.performedByUserName} label="Performed By" /></div>}
                        </div>
                        {this.state.orderPhase.notes && <FormLabel model={this.state.orderPhase.notes} label="Notes" />}
                        {this.props.phase?.isFinal && this.props.order?.dischargeStatusName && <FormLabel model={this.props.order?.dischargeStatusName} label="Discharge Status" />}
                    </Card>}
                    {this.props.phase?.isProductPhase && <Card>
                        <h5><L>Products on this Phase</L></h5>
                        <table className="table table-bordered">
                            <thead>
                                <tr>
                                    <th>Product</th>
                                    <th>Lot Number</th>
                                    <th>Expiration Date</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.orderPhase?.products?.map((i, idx) => <tr key={idx}>
                                    <td>{i.productName}</td>
                                    <td>{i.lotNumber}</td>
                                    <td>{Globals.toMDYLocalDateString(i.expirationDate)}</td>
                                </tr>)}
                            </tbody>
                        </table>
                        <div className="mt-2 d-flex gap-3 align-items-center">
                            {this.props.phase?.id === this.props.order?.phaseID && <Link to={'/order/view/' + this.state.order?.id + '/products/add'} role="button" className="btn btn-primary" onClick={this.hide}>
                                <Icon icon="faPlus" /> <L>Add Product</L>
                            </Link>}
                            <Link to={'/order/view/' + this.state.order?.id + '/products'} role="button" onClick={this.hide}>
                                <L>View Patient Products</L>
                            </Link>
                        </div>
                    </Card>}
                    {this.state.examObj && this.state.exam && <>
                        <Card>
                            {this.state.examObj && <small className="d-block text-secondary mb-3">From Examination Date: {Globals.toMDYHMLocalDateString(this.state.examObj.createdDate)}</small>}
                            {this.state.exam && <>
                                <div className="row">
                                    <div className="col">
                                        <FormLabel model={this.state.exam.bloodPressure} label="Blood Pressure" />
                                    </div>
                                    <div className="col">
                                        <FormLabel model={this.state.exam.temperature} label="Temperature" />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <FormLabel model={this.state.exam.heartRate} label="Heart Rate" />
                                    </div>
                                    <div className="col">
                                        <FormLabel model={this.state.exam.pulseOx} label="Pulse Ox" />
                                    </div>
                                </div>
                            </>}
                        </Card>
                    </>}
                    {this.state.wounds && this.state.wounds.length !== 0 && <Card>
                        <h5><L>Wounds</L></h5>
                        <div className="row">
                            {this.state.wounds?.map(i => <div className="col-6 col-md-4" key={i.id}>
                                <Wound visit={this.state.visit} item={i} allowEdit={false} edit={false} />
                            </div>)}
                        </div>
                    </Card>}
                </Modal.Body>
                <Modal.Footer>
                    <button type="button" className="btn btn-secondary btn-lg" onClick={this.hide}>
                        <L>Close</L>
                    </button>
                </Modal.Footer>
            </form>
        </Modal>;
    }
}

class SelectPhaseModal extends BaseCom {
    constructor(props) {
        super(props);
        this.submit = this.submit.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        PatientLifecycleGlobal.showSelect = this.show;
    }

    async componentDidMount() {
        this.setState({ show: this.props.show, order: { ...this.props.order } });
        await this.fillListAsync('/api/order/discharge-status/list', 'dischargeStatusList');
        await this.fillListAsync('/api/user/list?roleName=user&showDisabled=false', 'userList');
        this.loadPhase(this.props.order.phase);
    }

    componentDidUpdate(prevProps) {
        if (this.props.show !== prevProps.show)
            this.setState({ show: this.props.show });
        if (this.props.order !== prevProps.order) {
            this.setState({ order: { ...this.props.order } });
            this.loadPhase(this.props.order.phase);
        }
    }

    loadPhase = (phase) => {
        if (!phase?.id)
            return;
        qreq.get('/api/phase/order/' + this.props.order.id + '/get/' + phase.id, j => {
            if (j.item) {
                this.setState({ orderPhase: j.item, order: { ...this.state.order, phaseNotes: j.item.notes, assignedToUserID: j.item.assignedToUserID } });
            }
            else if (j.errorCode === 4)
                this.setState({ orderPhase: {} });
            else
                this.alert(j.errorMessage);
        }, this.unkownErrorCallback);
    }

    changePhase = (v) => {
        this.loadPhase(this.getPhase(Number(v)));
    }

    show() {
        this.setState({ show: true });
    }

    hide(success) {
        this.props.onHide?.();
        if (success)
            this.props.onSuccess?.();
        this.setState({ show: false });
    }

    getPhase = (id) => {
        return this.props.phases.find(i => i.id === Number(id));
    }

    change = () => {
        this.setState({ order: { ...this.state.order } });
    }

    submit(e) {
        if (e) e.preventDefault();
        let order = { ...this.state.order };
        let phase = this.getPhase(order.phaseID);
        if (!phase.isFinal)
            order.dischargeStatusID = 0;
        this.setState({ saving: true });
        qreq.post('/api/phase/update/order', order, j => {
            if (j.errorCode === 0) {
                this.success('Phase updated successfully');
                this.hide(true);
                this.props.onSuccess?.(order);
            }
            else
                this.alert(j.errorMessage);
            this.setState({ saving: false });
        }, (e) => {
            this.unkownErrorCallback(e);
            this.setState({ saving: false });
        });
    }

    render() {
        if (!this.state.show) return;
        return <Modal show={this.state.show} onHide={this.hide} size="xl">
            <Modal.Header closeButton>
                <Modal.Title><L>Next Phase</L></Modal.Title>
            </Modal.Header>
            <form onSubmit={this.submit}>
                <Modal.Body>
                    {this.state.order && <>
                        <FormInput model={this.state.order} name="performedByUserID" label="Current phase was perfomed by" type="select" options={this.state.userList} onChange={this.change} selectDefault="Select" />
                        <FormInput model={this.state.order} name="performedDate" label="Date phase was performed" type="date" onChange={this.change} />
                        <FormInput model={this.state.order} name="phaseNotes" label="Notes" type="textarea" rows={5} onChange={this.change} />
                        <hr />
                        <FormInput model={this.state.order} name="phaseID" label="Move to next phase" type="select" options={this.props.phases} onChange={this.changePhase} selectDefault="Select" required />
                        <FormInput model={this.state.order} name="assignedToUserID" label="Assign To" type="select" options={this.state.userList} onChange={this.change} />
                        {this.getPhase(this.state.order.phaseID)?.isFinal && <>
                            <FormInput model={this.state.order} name="dischargeStatusID" label="Discharge Status" type="select" options={this.state.dischargeStatusList ?? []} required onChange={this.change} />
                        </>}
                    </>}
                </Modal.Body>
                <Modal.Footer>
                    <button type="submit" className="btn btn-success btn-lg" disabled={this.state.saving}><Icon icon="faSave" /> <L>Save</L></button>
                </Modal.Footer>
            </form>
        </Modal>;
    }
}

export default class PatientLifecycle extends BaseCom {
    constructor(props) {
        super(props);
        this.state = {
            order: null,
            phases: [],
        };
        this.lifecycleRef = React.createRef();
        this.currentPhaseRef = React.createRef();
        this.load = this.load.bind(this);
        this.phaseClick = this.phaseClick.bind(this);
    }

    componentDidMount() {
        qreq.get('/api/phase/list', j => {
            if (j.list)
                this.setState({ phases: j.list })
        });
        this.load();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.props.orderID !== prevProps.orderID || this.props.order !== prevProps.order)
            this.load();

        if (prevState.order !== this.state.order || prevState.phases !== this.state.phases)
            this.scrollToCurrentPhase();
    }

    scrollToCurrentPhase = () => {
        const container = this.lifecycleRef.current;
        const current = this.currentPhaseRef.current;

        if (!container || !current || container.scrollWidth <= container.clientWidth)
            return;

        const left = current.offsetLeft - (container.clientWidth / 2) + (current.offsetWidth / 2);

        container.scrollTo({
            left: Math.max(0, left),
            behavior: 'smooth'
        });
    }

    load() {
        if (this.props.order) {
            this.setState({ order: this.props.order });
        }
        else if (this.props.orderID) {
            qreq.get('/api/order/get/' + this.props.orderID, j => {
                if (j.item)
                    this.setState({ order: j.item });
            });
        }
    }

    phaseClick(phase) {
        if (this.state.order?.phase.orderIndex < phase.orderIndex || !this.state.order?.phaseList?.find(a => a.phaseID === phase.id)?.touchDate)
            return;
        this.setState({ phase: phase });
        PatientLifecycleGlobal.showDetail();
    }

    render() {
        if (!this.state.order)
            return null;

        const currentOrderIndex = this.state.order?.phase?.orderIndex;

        return <>
            <SelectPhaseModal show={this.state.showSelectPhase} onHide={() => this.setState({ showSelectPhase: false })} order={this.state.order} phases={this.state.phases} onSuccess={this.props.onChange} />
            <DetailPhaseModal show={this.state.showDetailPhase} onHide={() => this.setState({ showDetailPhase: false })} order={this.state.order} phase={this.state.phase} />
            <Card title="Patient Lifecycle" headerButtons={<button type="button" className="btn btn-primary" onClick={() => this.setState({ showSelectPhase: true })}><Icon icon="faPen" /> <L>Change Phase</L></button>}>
                <div ref={this.lifecycleRef} className="patient-lifecycle">
                    <div className="lifecycle-track">
                        {this.state.phases?.map((phase, index) => {
                            const phaseHistory = this.state.order?.phaseList?.find(a => a.phaseID === phase.id);
                            const hasDate = !!phaseHistory?.touchDate;
                            const isCurrent = currentOrderIndex === phase.orderIndex && hasDate;
                            const isPast = currentOrderIndex > phase.orderIndex;
                            const isCompleted = isPast && hasDate;
                            const isSkipped = isPast && !hasDate;
                            const isAvailable = currentOrderIndex >= phase.orderIndex && hasDate;
                            const stateClass = isCurrent ? 'current' : isCompleted ? 'completed' : isSkipped ? 'skipped' : 'upcoming';

                            return <div ref={isCurrent ? this.currentPhaseRef : null} className={`lifecycle-step ${stateClass}`} key={phase.id}>
                                {index !== 0 && <div className="lifecycle-connector">
                                    <div className={'lifecycle-connector-line ' + (isSkipped ? 'skipped' : (isCompleted || isCurrent ? 'completed' : ''))} />
                                </div>}
                                <button
                                    type="button"
                                    className="lifecycle-step-button"
                                    disabled={!isAvailable}
                                    onClick={() => this.phaseClick(phase)}
                                    title={isAvailable ? `View ${phase.name}` : phase.name}>
                                    <div className="lifecycle-marker" style={isCompleted || isCurrent ? { backgroundColor: phase.color } : undefined}>
                                        {isCompleted && <Icon icon="faCheck" />}
                                        {isCurrent && <span className="lifecycle-current-dot" />}
                                        {isSkipped && <span className="lifecycle-skip-mark">—</span>}
                                        {!isCompleted && !isCurrent && !isSkipped && <span className="lifecycle-step-number">{index + 1}</span>}
                                    </div>
                                    <div className="lifecycle-content">
                                        <div className="lifecycle-phase-name">{phase.name}</div>
                                        {isCurrent && <div className="lifecycle-status current">Current Phase</div>}
                                        {isCompleted && <div className="lifecycle-status completed">Completed</div>}
                                        {isSkipped && <div className="lifecycle-status skipped">No Data</div>}
                                        {!isCurrent && !isCompleted && !isSkipped && <div className="lifecycle-status upcoming">Upcoming</div>}
                                        {hasDate && (isCompleted || isCurrent) && <div className="lifecycle-date">{Globals.toMDYHMLocalDateString(phaseHistory.touchDate)}</div>}
                                    </div>
                                </button>
                            </div>;
                        })}
                    </div>
                </div>
            </Card>
        </>;
    }
}